// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3O1IF","notes":"Notes_notes__1F_QY","note":"Notes_note__12gGU","markdown":"Notes_markdown__3NpOZ"};